import { capitalize } from 'lodash';
import toString from './toString';

const toStringWithoutQuestions2 = toString.with({
  OneOf: (label, options, answer) => (answer ? `${answer.label}${answer.child ? ` (${answer.child})` : ''}` : null),
  YesNo: (question, positive, child) => {
    const item = capitalize(
      question
        .replace(/\?/g, '')
        .replace(/^Do you have\s/g, '')
        .replace(/^Are you a\s/g, '')
        .replace(/^Are you\s/g, '')
        .replace(/^Any chance you may be\s/g, '')
        .replace(/^Did you\s/g, '')
        .replace(/^Any\s/g, '')
        .replace(/^Have you ever\s/g, '')
        .replace(/^Have you\s/g, '')
        .replace(/^Is it a\s/g, '')
        .replace(/^Do you\s/g, '')
        .replace(/^Does your\s/g, '')
        .replace(/^Has\s/g, '')
        .replace(/\(difficulty placing breathing tube for general anesthesia\)/g, '')
        .replace(/^Postoperative nausea and vomiting \(PONV\)/g, 'PONV')
    );
    return positive ? `${item}${child ? `(${child})` : ''}` : '';
  },
});

export default toStringWithoutQuestions2;
